export class Config {
  public author: number;
  public enabled: boolean;
  public modifiedAt: string;
  constructor(author = 0, enabled = false, modifiedAt = "") {
    this.author = author;
    this.enabled = enabled;
    this.modifiedAt = modifiedAt;
  }
}
